// @ts-nocheck
import React from 'react'
import { useSelector } from 'react-redux'
import { QRCodeSVG } from 'qrcode.react'

import { style } from 'src/components/Print/TicketStyles'

import { haveAnyValue } from 'src/utils/utilitiesV2'
import { IPrintInstruction, IPrintInstructionTableItem } from 'types/Printers/Printers'
import { selectPrintInstructions } from 'src/selectors/printer.selector'
import { PrintInstructionType } from 'src/enums/printerEnum'
import {
  selectCompanyCountry,
  selectCompanyFieldById,
} from 'src/selectors/company.selector'
import { Country } from 'src/enums/countries'
import { selectCurrentCurrency } from 'src/selectors/currencies.selector'
import { companyFieldsInvoice } from 'src/enums/companyFields'

interface IHTMLBuilderProps {
  logo?: string
  htmlId: string
  type: number
  instructions: IPrintInstruction[]
}
const HTMLBuilder = () => {
  const printInstructions: IHTMLBuilderProps = useSelector(selectPrintInstructions)
  const country = useSelector(selectCompanyCountry)
  const instructions: IPrintInstruction[] = printInstructions?.instructions || []
  const id = printInstructions?.htmlId
  const logo = printInstructions?.logo
  const type: number = printInstructions?.type
  const currency = useSelector(selectCurrentCurrency)
  const { cursive, title, subtitle, text, right, dFlex, body, spaceBetween, bold } = style
  const showTax =
    useSelector(state =>
      selectCompanyFieldById(state, companyFieldsInvoice.displayTaxInPDFInvoice),
    )?.value === 'true'

  const itemsOfInvoice = (items: IPrintInstructionTableItem[]): React.JSX.Element => {
    return (
      <div style={{ width: '100%' }}>
        {/* HEADERS */}

        <div style={{ ...dFlex, ...bold, ...text }}>
          {country?.id === Country.HN && showTax && (
            <div style={{ width: '4%' }}>ISV</div>
          )}
          <div style={{ width: '11%' }}>Cant</div>
          <div style={{ width: '49%' }}>Descripción</div>
          <div style={{ width: '20%', ...right }}>Precio</div>
          <div style={{ width: '20%', ...right }}>Monto</div>
        </div>

        {/* ITEMS */}

        {items.map((item: IPrintInstructionTableItem, index) => (
          <div style={{ ...dFlex, ...text }} key={index}>
            {country?.id === Country.HN && showTax && (
              <div style={{ width: '4%' }}>{item.tax}</div>
            )}
            <div style={{ width: '11%' }}>{item.quantity}</div>
            <div style={{ width: '49%' }}>
              {item.description}
              {haveAnyValue(item.commentary) && (
                <div style={{ ...cursive }}>{item.commentary}</div>
              )}
            </div>
            <div style={{ width: '20%', ...right }}>{item.price}</div>
            <div style={{ width: '20%', ...right }}>
              {country?.id === Country.HN ? currency.symbol : ''}
              {item.amount}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div style={{ display: 'none' }}>
      <div id={id} style={{ paddingRight: 50, width: '100%', ...body }}>
        <div style={{ ...body }}>
          {instructions?.map((instruction, index) => {
            switch (instruction.type) {
              case 'title':
                return (
                  <div
                    key={index}
                    style={{
                      textAlign: instruction.align,
                      ...title,
                      ...{ bold: instruction.bold ? bold : {} },
                    }}>
                    {instruction.value}
                  </div>
                )
              case 'sub_title':
                return (
                  <div
                    key={index}
                    style={{
                      textAlign: instruction.align,
                      ...subtitle,
                      ...{ bold: instruction.bold ? bold : {} },
                    }}>
                    {instruction.value}
                  </div>
                )
              case 'text': {
                let custom = {}
                if (haveAnyValue(instruction.space))
                  custom.paddingLeft = `${10 * instruction.space}px`
                if (instruction.bold) custom = { ...custom, ...bold }

                if (instruction.align === 'space_between')
                  return (
                    <div
                      key={index}
                      style={{
                        ...spaceBetween,
                      }}>
                      <div style={{ ...text, ...custom }}>{instruction.value}</div>
                      <div style={{ ...text, ...custom }}>{instruction.secondValue}</div>
                    </div>
                  )

                return (
                  <div
                    key={index}
                    style={{
                      textAlign: instruction.align,
                      ...text,
                      ...custom,
                    }}>
                    {instruction.value}
                  </div>
                )
              }

              case 'separator':
                return <br />
              case 'table': {
                switch (type) {
                  case PrintInstructionType.SELL:
                    return itemsOfInvoice(instruction.items)
                  default:
                    return <div />
                }
              }
              case 'QR':
                return (
                  <div style={{ textAlign: 'center' }} key={index}>
                    <QRCodeSVG
                      value={instruction.value}
                      size={75}
                      bgColor="#f5f5f5"
                      fgColor="#000000"
                    />
                  </div>
                )
              default:
                return <></>
            }
          })}
        </div>

        {country.id === Country.HN && (
          <div
            style={{
              marginTop: '10px',
              textAlign: 'center',
            }}>
            Original: Cliente <br />
            Copia: Obligado Tributario Emisor
          </div>
        )}
      </div>

      <div style={{ display: 'none' }}>
        <canvas id={'invoice-canvas'} width={300} height={275} />
        {logo && (
          <img
            id={'invoice-ticket-logo'}
            alt={'logo'}
            src={`data:image/bmp;base64,${logo}`}
          />
        )}
      </div>
    </div>
  )
}
export default HTMLBuilder
